import React from 'react';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Drawer from '@material-ui/core/Drawer';
import { MaintenanceBanner } from '@shared/components';
import { SharedService } from '@consumers/services';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import PoweredIcon from '@assets/icons/powered-icon.png';
import useStyles from './style';

export default ({
  children = null,
  drawerList = [],
  onDrawerToggle = () => {},
  headerContent = <></>,
  classes: passedClasses = {},
  hideSideBar = false,
}) => {
  const [maintenanceStartTime, setMaintenanceStartTime] = React.useState(null);
  const classes = useStyles({ maintenanceStartTime });

  const handleMaintenanceSlotChange = startTime => {
    setMaintenanceStartTime(startTime);
  };

  return (
    <div className={classes.root}>
      <div className={clsx('d-flex w-100 p-fixed', classes.appBar)}>
        {headerContent}
      </div>
      {!hideSideBar && (
        <Drawer
          variant='permanent'
          className={clsx(classes.drawer, classes.drawerOpen)}
          classes={{
            paper: classes.drawerOpen,
          }}
        >
          <List
            className={clsx(classes.toolbarSpacing, passedClasses.drawerList)}
          >
            {drawerList.map((listItem, index) => {
              let content = listItem.render || null;
              if (!content) {
                content = (
                  <>
                    <ListItemIcon
                      className={clsx(
                        'f-justify-center',
                        classes.listItemIcon,
                        passedClasses.drawerListItem
                      )}
                    >
                      <img
                        alt=''
                        src={listItem.icon}
                        className='sidebar-list-icon'
                      />
                      <img
                        alt=''
                        src={listItem.activeIcon}
                        className='sidebar-list-active-icon'
                      />
                    </ListItemIcon>
                    <ListItemText
                      className={clsx(
                        classes.fadeOutElement,
                        passedClasses.listItemText
                      )}
                      primary={listItem.label}
                    />
                  </>
                );
              }
              return (
                <ListItem
                  component={NavLink}
                  activeClassName={classes.activeListItem}
                  to={listItem.to}
                  key={`drawer-list-item-${listItem.to || index}`}
                  className={clsx(classes.listItem, {
                    'c-default': listItem.canNavigateTo
                      ? !listItem.canNavigateTo()
                      : false,
                  })}
                >
                  {content}
                </ListItem>
              );
            })}
          </List>
          <div className={classes.poweredBy}>
            <p className={classes.fadeOutElement}>Powered by</p>
            <img alt='Powered by brand icon' src={PoweredIcon} />
            <div className={classes.fadeOutElement}>
              Professional
              <br /> Services
            </div>
          </div>
        </Drawer>
      )}
      <div
        className={clsx(
          'w-100',
          classes.toolbarSpacing,
          classes.contentContainer
        )}
      >
        {children}
      </div>
      <div className={classes.poweredBy}>
        <p className={classes.fadeOutElement}>Powered by</p>
        <img alt='Powered by brand icon' src={PoweredIcon} />
        <div className={classes.fadeOutElement}>Professional Services</div>
      </div>
    </div>
  );
};
